import {createEntitySlice} from 'utils/createEntitySlice';
import {DocumentTemplateProgram} from '../../../../types/documentTemplateProgram';
import {DocumentTemplateProgramThunks} from './documentTemplateProgramThunks';

export interface DocumentTemplateProgramState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  documentTemplatePrograms?: any;
  pagy?: any;
  documentTemplateProgram?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: DocumentTemplateProgramState = {
  status: 'idle',
  error: null,
  documentTemplatePrograms: [],
  documentTemplateProgram: null,
  pagy: {},
  isEditing: false,
  activeTab: 'Report Templates',
};

const documentTemplateProgramSlice = createEntitySlice<DocumentTemplateProgram>(
  {
    name: 'Report Template',
    initialState,
    thunks: DocumentTemplateProgramThunks,
    entityKey: 'documentTemplateProgram',
    entitiesKey: 'documentTemplatePrograms',
    reducers: {},
  },
);

export const {
  setEntity: setDocumentTemplateProgram,
  setIsEditing,
  setActiveTab,
} = documentTemplateProgramSlice.actions;
export {initialState as documentTemplateProgramInitialState};
export default documentTemplateProgramSlice.reducer;
